import { i18next } from '@yola/ws-sdk';

const validatePagePassword = (value) => {
  if (!value) {
    return i18next.t('Page password should not be empty');
  }

  return null;
};

export default validatePagePassword;
